module.exports = __webpack_public_path__ + "static/media/empty-templates.b819e7ba.png";